module.exports = __webpack_public_path__ + "img/front_fire.09067cef.png";